import { useEffect, useCallback } from 'react';

interface OAuthPopupProps {
  popupWindow: Window | null;
  authUrl: string | null;
  onSuccess: (connectionId: string) => void;
  onError: (error: string) => void;
}

interface OAuthCallbackData {
  type: string;
  success?: boolean;
  connection_id?: string;
  error?: string;
}

function isOAuthCallbackData(data: unknown): data is OAuthCallbackData {
  return typeof data === 'object' && data !== null && 'type' in data && typeof (data as OAuthCallbackData).type === 'string';
}

export function OAuthPopup({ popupWindow, authUrl, onSuccess, onError }: OAuthPopupProps) {
  const handleMessage = useCallback((event: MessageEvent<unknown>) => {
    const data = event.data;
    if (isOAuthCallbackData(data) && data.type === 'oauth_callback') {
      if (data.success) {
        onSuccess(data.connection_id ?? '');
      } else {
        onError(data.error ?? 'OAuth failed');
      }
    }
  }, [onSuccess, onError]);

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [handleMessage]);

  useEffect(() => {
    if (authUrl && popupWindow && !popupWindow.closed) {
      popupWindow.location.assign(authUrl);
    }
  }, [authUrl, popupWindow]);

  return null;
}
